var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookSpark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6894 21.6625C17.5811 24.7708 16.027 28.559 16.027 33.0271C16.027 28.559 14.4729 24.7708 11.3646 21.6625C8.25633 18.5543 4.46813 17.0001 0 17.0001C4.46813 17.0001 8.25633 15.446 11.3646 12.3377C14.4729 9.22947 16.027 5.44127 16.027 0.973145C16.027 5.44127 17.5811 9.22947 20.6894 12.3377C23.7976 15.446 27.5858 17.0001 32.054 17.0001C27.5858 17.0001 23.7976 18.5543 20.6894 21.6625Z",
    fill: "url(#paint0_linear_75_2490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_2490",
    x1: 30,
    y1: 16.9731,
    x2: 10.5,
    y2: 16.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#548BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSpark);
export default __webpack_public_path__ + "static/media/book_spark.ba5d3fd708413e5539cbbe3a666a559d.svg";
export { ForwardRef as ReactComponent };